import { ACCOUNT_TYPE } from '@reaffiliates/const';
import { TBaseDataLayer, ICustomDataLayer } from '@typescript/index';
const GoogleTagManagerNewSignIn = (userID: string) => {
  const tagManagerArgs: ICustomDataLayer<TBaseDataLayer, ['eventLabel', 'dimension1', 'dimension3']> = {
    event: 'ga4Event',
    eventAction: 'Logowanie',
    eventLabel: userID,
    dimension1: ACCOUNT_TYPE,
    dimension3: userID
  };
  if (window && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: null
    });
    window.dataLayer.push(tagManagerArgs);
  }
};
export default GoogleTagManagerNewSignIn;